var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterinline = function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.648 14C12.445 14 16.16 8.613 16.16 3.943q.002-.231-.008-.454A7.4 7.4 0 0 0 18 1.657a7.8 7.8 0 0 1-2.123.557A3.57 3.57 0 0 0 17.502.257a7.7 7.7 0 0 1-2.345.857A3.76 3.76 0 0 0 12.46 0C10.42 0 8.766 1.583 8.766 3.533q-.002.42.1.806C5.793 4.193 3.073 2.785 1.249.645a3.43 3.43 0 0 0-.498 1.774c0 1.224.651 2.309 1.648 2.94a3.76 3.76 0 0 1-1.671-.44v.043C.728 6.677 2 8.1 3.693 8.43a3.84 3.84 0 0 1-1.67.059c.467 1.407 1.831 2.426 3.448 2.455a7.65 7.65 0 0 1-4.59 1.51 7 7 0 0 1-.881-.05A10.64 10.64 0 0 0 5.648 14",
    clipRule: "evenodd"
  })));
};
export default SvgTwitterinline;